export const urls = {
    home: '/',
    error: '/error',
    tasksList: '/tasks-list',
    tasksGraph: '/tasks-graph',
    confirmationCalls: '/confirmation-calls',
    statistics: '/proposal',
    kpi: '/kpi',
    payments: '/payments',
    storageExpectedIncome: '/storage-expected-income',
    mcOpsDashboard: '/mc-ops-dashboard',
    mcOpsJob: '/mc-ops-dashboard/job/:jobId',
}
